// File#: _1_load-more-news

(function () {

    var newsListContainer = document.getElementsByClassName('news-list__news')[0];
    var loadMoreContainer = document.getElementsByClassName('news-list__load-more')[0];
    var loadMoreBtn = document.getElementsByClassName('news-list__load-more-btn')[0];

    if (loadMoreBtn && loadMoreContainer && newsListContainer) {
        loadMoreBtn.addEventListener('click', function () {

            Util.addClass(loadMoreContainer, 'news-list__load-more--loading');

            var newsListId = newsListContainer.dataset.newslist;
            var take = newsListContainer.dataset.take;
            var skip = newsListContainer.dataset.skip;
            var culture = newsListContainer.dataset.culture;

            var query = new URLSearchParams({ newsListId, take, skip, culture });

            fetch('/umbraco/surface/newssurface/getnews?' + query)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    console.log('Error loading news..');
                    return null;
                })
                .then(data => {
                    if (data) {
                        newsListContainer.insertAdjacentHTML('beforeend', data.partialView);
                        if (!data.canLoadMore) {
                            Util.addClass(loadMoreContainer, 'news-list__load-more--hide');
                            Util.setAttributes(newsListContainer, { 'data-skip': data.skip });
                        } else {
                            Util.setAttributes(newsListContainer, { 'data-skip': data.skip });
                            Util.removeClass(loadMoreContainer, 'news-list__load-more--loading');
                        }
                    }
                })
                .catch(error => console.log(error))
        });
    }
})();